import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { orgInfo, createCompany } from 'src/api';
import { company } from 'kts-platform-frame/api';
import department from 'src/api/systemManage/department';
import companyInfo from 'src/api/systemManage/companyInfo';
import { message } from 'antd';


class ModulesAction extends ActionBasic<ModulesState> {
    public getCompanyInfo = async (companyId) => {
        if (companyId) {
            const res = await orgInfo.getOrgQuery(this, {
                companyId: companyId
            });
            if (!res.er) {
                this.modulesState.orgId = res.res.orgId;
                this.modulesState.companyId = companyId;
                this.modulesState.expandedKeys = [companyId];
                this.setModulesState();
                this.departmentQuery(res.res.orgId);
                this.onSelect([companyId]);
            }
        }    
    }

    public departmentQuery = async (orgId) => {
        const res = await orgInfo.getCompanyList(this, {orgId: orgId});
        if(!res.er) {
            this.modulesState.departmentQuery = res.res;
            this.modulesState.treeDate = this.buildTree(this.modulesState.departmentQuery);
            this.setModulesState();
            this.generateList(this.modulesState.treeDate);
        }
    }

    public buildTree=(data)=>{
        let dataChildList=data.filter((item)=>item.pcompanyId);
        let dataRootList=[];
        for(let i=0; i<data.length; i++){
            data[i].children=[];
            if(!data[i].pcompanyId){
                dataRootList.push(data[i]);
            }
        }
        let tree = this.loopChildData(dataRootList, dataChildList);
        return tree;
    }

    public loopChildData=(parent, children, insert=false) => {
        for(let i=0; i<parent.length; i++){
            for(let x=0; x<children.length; x++){
                if(parent[i].companyId === children[x].pcompanyId){
                    parent[i].children.push(children[x]);
                }
            }
            if(parent[i].children.length > 0){
                this.loopChildData(parent[i].children, children, true);
            }
        }
        if(insert) {
            return;
        }else{
            return parent;
        }
    }
    /** 搜索框改变 */
    public onChange = (e) => {
        const value = e.target.value;
        const expandedKeys = this.modulesState.dataList.map((item) => {
          if (item.name.indexOf(value) > -1) {
            return this.getParentKey(item.companyId, this.modulesState.departmentQuery);
          }
          return null;
        }).filter((item, i, self) => item && self.indexOf(item) === i);
        this.modulesState.expandedKeys = expandedKeys;
        this.modulesState.searchValue = value;
        this.modulesState.autoExpandParent = true;
        this.setModulesState();
    }
     /** 获取父节点的key */
     public getParentKey = (key, tree) => {
        let parentKey;
        for (let i = 0; i < tree.length; i++) {
          const node = tree[i];
          if (node.children) {
            if (node.children.some(item => item.companyId === key)) {               
              parentKey = node.companyId;
            } else if (this.getParentKey(key, node.children)) {
              parentKey = this.getParentKey(key, node.children);
            }
          }
        }
        return parentKey;       
    }
    /** 获取数据key */
    public generateList = (data) => {
        for (let i = 0; i < data.length; i++) {
            const node = data[i];
            const companyId = node.companyId;
            this.modulesState.dataList.push({ companyId, name: node.name });
            if (node.children) {
              this.generateList(node.children);
            }
        }
    }
    /** 展开，收起节点触发 */
    public onExpand = (expandedKeys) => {
        this.modulesState.expandedKeys = expandedKeys;
        this.modulesState.autoExpandParent = false;
        this.setModulesState();
    }

    /** 当前公司被选中 */
    public onSelect = async (expandedKeys) => {
        if (expandedKeys.length > 0) {
            const res = await orgInfo.getCheckCompanyInfo(this, {companyId: expandedKeys[0]});
            if (!res.er) {
                this.modulesState.companyDetail = res.res;
                this.setModulesState();
            }
        }  
    }
    /** 
     * 添加公司
     * @param id -父公司Id
     */
    public addCompany = (id) => {
        this.modulesState.logView = true;
        this.modulesState.pcompanyId = id;
        this.setModulesState();
    }
     /** 获取国家列表 */
     public getCountry = async () => {
        const res = await createCompany.country(this, null);
        if (!res.er) {
            this.modulesState.countryList = res.res.countryList;
            this.setModulesState();
        }
    }
     /** 国家选择变化 */
     public countryChange = (value) => {
        if (value === 'CHN') {
            this.modulesState.isChina = true;
        }  else {
            this.modulesState.isChina = false;
        }
        this.setModulesState();
    }
    /** 获取省 */
    public getProvince = async (province) => {
        const res = await createCompany.state(this, {countryCode: province});
        if (!res.er) {
           this.modulesState.provinceList = res.res.provinceList;
           this.setModulesState();
        }
    }
    /** 省下拉框改变 */
    public provinceChange = async (value) => {      
        const res = await createCompany.city(this, {stateCode: value});
        if (!res.er) {
            this.modulesState.cityList = res.res.cityList;
            this.setModulesState();
        }      
    }
    /** 取消添加公司 */
    public cancel = (resetFields) => {
        this.modulesState.logView = false;
        this.setModulesState();
        resetFields();
    }
    /** 添加公司 */
    public createCompany = async(validateFieldsAndScroll, resetFields) => {
        validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                const res = await orgInfo.create(this, {...values, pcompanyId: this.modulesState.pcompanyId});
                if (!res.er) {
                    message.success('创建公司成功');
                    this.modulesState.logView = false;
                    this.setModulesState();
                    resetFields();
                    this.generateList(this.modulesState.treeDate);
                    this.departmentQuery(this.modulesState.orgId);
                    await company.list(this, null);
                    // const ress = await orgInfo.getOrgQuery(this, {
                    //     companyId: companyId
                    // });
                    // if (!res.er) {
                    //     this.modulesState.orgId = res.res.orgId;
                    //     this.modulesState.companyId = companyId;
                    //     this.modulesState.expandedKeys = [companyId];
                    //     this.setModulesState();
                    //     this.departmentQuery(res.res.orgId);
                    //     this.onSelect([companyId]);
                    // }
                }
            }
        });
    }
    public preCheck = async options => {
        const res = await orgInfo.companyInfoPreTreated(this, options);
        if(!res.er) {
            return res.res;
        }
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/apps/GroupInfo/Modules.Action.ts